export const TextFieldStyles = {
  border: 'none',
  borderRadius: '40px',
  width: '99%',
  backgroundColor: (theme: any) => (theme.palette.mode === 'light' ? '#f7f6f9' : 'grey.800'),
};
